// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authReducer'; // adjust path if needed

const store = configureStore({
  reducer: {
    auth: authReducer,
    // add more reducers here if needed
  },
});

export default store;
